import React from "react";
import HomeComponent from "../components/Home/HomeComponent";
import LayoutComponent from "../components/Layout/LayoutComponent";
import LayoutHomeComponent from "../components/Layout/LayoutHomeComponent";

const HomeContainer: React.FC = () => {
  const conteudo = (
    <React.Fragment>
      <HomeComponent />
    </React.Fragment>
  );

  return <LayoutHomeComponent content={conteudo} />;
};

export default HomeContainer;
